var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgUy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.337h512v48.762H0zm0 97.525h512v48.762H0zm0 97.525h512v48.762H0zM0 377.9h512v48.762H0z",
  fill: "#338af3"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h256v195.05H0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M192 182.857l-26.151 12.301 13.925 25.327-28.397-5.433-3.598 28.687L128 222.641l-19.78 21.098-3.597-28.687-28.397 5.432 13.925-25.326L64 182.857l26.151-12.301-13.925-25.326 28.396 5.432 3.599-28.687L128 143.074l19.78-21.099 3.597 28.687 28.398-5.432-13.926 25.327z"
})));

export default SvgUy;